import { LanguageOption } from '../types/language-select'

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  {
    value: 'ko',
    label: '한국어',
    // flag: '🇰🇷'
  },
  {
    value: 'en',
    label: 'English',
    // flag: '🇺🇸'
  },
  {
    value: 'zh',
    label: '中文'
    // flag 없음 - language-icon.svg 사용
  },
  {
    value: 'ja',
    label: '日本語'
    // flag 없음 - language-icon.svg 사용
  }
]
